import { ridesharingList } from './ridesharing-list/ridesharing-list.module';
import { ridesharingAdd } from './ridesharing-add/ridesharing-add.module';
import { ridesharingEdit } from './ridesharing-edit/ridesharing-edit.module';
import { ridesharingMain } from './ridesharing-main/ridesharing-main.module';
import { ridesharingDetails } from './ridesharing-details/ridesharing-details.module';

export const ridesharing = angular
	.module('components.transportationAlternative.ridesharing', [
		ridesharingList,
		ridesharingAdd,
		ridesharingEdit,
		ridesharingMain,
		ridesharingDetails
	])
	.name;



// WEBPACK FOOTER //
// ./src/app/components/transportation-alternative/ridesharing/ridesharing.module.js